import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { getPropertyManagerList } from '@/lib/coloc-api/admin';
import { useContractsListFiltersContext } from '../../../../../../hooks/use-get-contracts-list-filter';
import { PropertyManager } from '@/features/admin/contracts/types';

const PropertyManagersFilter = () => {
  const { t } = useTranslation();
  const { propertyManagerId, setPropertyManagerId } = useContractsListFiltersContext();

  const { data: response } = useQuery({
    queryKey: ['getPropertyManagerList'],
    queryFn: async () => {
      const response = await getPropertyManagerList();
      return response.data;
    },
  });

  const propertyManagers = response?.data || [];
  const selectedManager = propertyManagers.find(
    (manager: PropertyManager) => manager.id === propertyManagerId
  );

  return (
    <div className="flex min-w-[200px] flex-col">
      <DropDown
        placeholder="All"
        className="w-[200px]"
        showLabel
        label={'Property Manager'}
        value={selectedManager}
        {...(selectedManager && {
          displayValue: `${selectedManager.first_name} ${selectedManager.last_name}`,
        })}
        onChange={(manager: PropertyManager) => setPropertyManagerId(manager?.id)}
      >
        <DropDown.DropDownOptions>
          <DropDown.DropDownOption key="all" value={undefined}>
            <DropDown.DropDownOptionDefaultContent>All</DropDown.DropDownOptionDefaultContent>
          </DropDown.DropDownOption>
          {propertyManagers.map((manager: PropertyManager) => (
            <DropDown.DropDownOption key={manager.id} value={manager}>
              <DropDown.DropDownOptionDefaultContent>
                {`${manager.first_name} ${manager.last_name}`}
              </DropDown.DropDownOptionDefaultContent>
            </DropDown.DropDownOption>
          ))}
        </DropDown.DropDownOptions>
      </DropDown>
    </div>
  );
};

export { PropertyManagersFilter };
